import {isString} from "../../types/guards/isString";

export function cssClasses(...classes: unknown[]) {
    return classes
        .filter(isString)
        .join(' ');
}